import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { styled } from 'styled-components'

interface PrintReportHeaderProps {
  companyName?: string
  reportTitle: string
  date?: string
  logoUrl?: string | null
  contractId?: string
  token?: string
}

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e8e8e8;
`

const Logo = styled.img`
  max-height: 60px;
  max-width: 200px;
  object-fit: contain;
`

const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

const CompanyName = styled.div`
  font-size: var(--print-font-md, 10.5pt);
  font-weight: 600;
  color: #262626;
`

const ReportTitle = styled.div`
  font-size: var(--print-font-base, 9pt);
  color: #595959;
`

const ReportDate = styled.div`
  font-size: var(--print-font-sm, 8pt);
  color: #8c8c8c;
`

const useFetchLogo = (contractId?: string, token?: string) => {
  const [url, setUrl] = useState<string | null>(null)

  useEffect(() => {
    if (!contractId || !token) return undefined

    let objectUrl: string | null = null

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/contracts/${contractId}/logo`, {
        headers: { 'X-Token': token },
        responseType: 'blob'
      })
      .then(response => {
        objectUrl = URL.createObjectURL(new Blob([response.data]))
        setUrl(objectUrl)
      })
      .catch(() => {
        setUrl(null)
      })

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [contractId, token])

  return url
}

const PrintReportHeader: React.FC<PrintReportHeaderProps> = ({
  companyName,
  reportTitle,
  date,
  logoUrl: logoUrlProp,
  contractId,
  token
}) => {
  const fetchedLogo = useFetchLogo(contractId, token)
  const logoUrl = logoUrlProp !== undefined ? logoUrlProp : fetchedLogo

  return (
    <Header>
      {logoUrl && <Logo src={logoUrl} alt="" />}
      <Info>
        {companyName && <CompanyName>{companyName}</CompanyName>}
        <ReportTitle>{reportTitle}</ReportTitle>
        {date && <ReportDate>{date}</ReportDate>}
      </Info>
    </Header>
  )
}

export default PrintReportHeader
